import { COUNTRIES, EnvEnum, WEB_FORM_AUTOFILL_FIELD, WEB_FORM_TYPE } from './locale';

// in-house webform 组件映射
export const webformWidgetMap: any = {
  DropdownList: 'Select',
  ShopeeUserName: 'Input',
  ShopeeUserNameWithRegion: 'InputWithRegion',
  Answer: 'Answer',
  EmailAddress: 'Email',
  userEmail: 'Email',
  RequestEmail: 'RequestEmail',
  FileUpload: 'FileUpload',
  PhoneNumber: 'PhoneNumber',
  OrderInfo: 'WebFormOrder',
};

// old webform 展示，但新的 webform 不展示的字段
export const webformHiddenFields: string[] = ['shopeeUsername', 'c2cf1fbace', 'f343063743'];
export const hardcodeSpecialComponent = [webformWidgetMap.RequestEmail, webformWidgetMap.ShopeeUserNameWithRegion];
export const webformHiddenWidgets: string[] = ['DescriptionArea'];
// export const webformDescriptionFields: string[] = [];
// old webform 展示，但新的 webform 会在第一步展示的字段
export const webformDisplayFields: any = {
  // live
  c46c8910b6c24f44bed76e06803613ff: ['16b26d06b2'], // webform 1
  '66a9b2f2569a49dcbb5bfc8413fd50f9': ['4825eb2824', '52de0c486d'], // webform2 PH SpayLater
  '9624dbe91efa499db827865f2e4f8c45': ['44049630a4', '9e99a2ec1d'], // webform7 ID - Tim SPX Express Support

  // test
  '03d4aaecec9c41fbb35f0b6c9ef5bcdc': ['16b26d06b2'], // webform 1
  '1d308a3ae84d497e88e9f0e162b3fdd7': ['4825eb2824', '52de0c486d'], // webform2 PH SpayLater
  '07592f5923ab4ae98ee0daa8f28e5469': ['44049630a4', '9e99a2ec1d'], // webform7 ID - Tim SPX Express Support

  // uat
  e483f652228e4a7ebc68c87ef596dfc1: ['16b26d06b2'], // webform 1
  c07a630f2a0343dbbc9058458ce87c15: ['4825eb2824', '52de0c486d'], // webform2 PH SpayLater
  '12149cbb24da4af79e61eea4d8f6d5f2': ['44049630a4', '9e99a2ec1d'], // webform7 ID - Tim SPX Express Support
};

export const INHOUSE_WEB_FORM_MAP
  = {
    [COUNTRIES.ID]: {
      [EnvEnum.TEST]: {
        [WEB_FORM_TYPE.Normal]: {
          url: 'https://help.test.shopee.co.id/portal/webform/a971bf5eb6554489aafa53281fd57c30',
          fieldIdMap: {
            [WEB_FORM_AUTOFILL_FIELD.userType]: '31aa7595ea',
            [WEB_FORM_AUTOFILL_FIELD.enquiryType]: 'd9bf313b14',
            [WEB_FORM_AUTOFILL_FIELD.description]: '59286c8df1',
            [WEB_FORM_AUTOFILL_FIELD.attachments]: '2b3c006ef4',
            [WEB_FORM_AUTOFILL_FIELD.orderSN]: 'e98105d0ba',
          },
        },
        [WEB_FORM_TYPE.Premium]: {
          url: 'https://help.test.shopee.co.id/portal/webform/a971bf5eb6554489aafa53281fd57c30',
          fieldIdMap: {
            [WEB_FORM_AUTOFILL_FIELD.userType]: '31aa7595ea',
            [WEB_FORM_AUTOFILL_FIELD.enquiryType]: 'd9bf313b14',
            [WEB_FORM_AUTOFILL_FIELD.description]: '59286c8df1',
            [WEB_FORM_AUTOFILL_FIELD.attachments]: '2b3c006ef4',
            [WEB_FORM_AUTOFILL_FIELD.orderSN]: 'e98105d0ba',
          },
        },
      },
      [EnvEnum.UAT]: {
        [WEB_FORM_TYPE.Normal]: {
          url: 'https://help.uat.shopee.co.id/portal/webform/3c44902b7cb342bbab562e59b0a5bb7d',
          fieldIdMap: {
            [WEB_FORM_AUTOFILL_FIELD.userType]: '31aa7595ea',
            [WEB_FORM_AUTOFILL_FIELD.enquiryType]: 'd9bf313b14',
            [WEB_FORM_AUTOFILL_FIELD.description]: '59286c8df1',
            [WEB_FORM_AUTOFILL_FIELD.attachments]: '2b3c006ef4',
            [WEB_FORM_AUTOFILL_FIELD.orderSN]: 'e98105d0ba',
          },
        },
        [WEB_FORM_TYPE.Premium]: {
          url: 'https://help.uat.shopee.co.id/portal/webform/3c44902b7cb342bbab562e59b0a5bb7d',
          fieldIdMap: {
            [WEB_FORM_AUTOFILL_FIELD.userType]: '31aa7595ea',
            [WEB_FORM_AUTOFILL_FIELD.enquiryType]: 'd9bf313b14',
            [WEB_FORM_AUTOFILL_FIELD.description]: '59286c8df1',
            [WEB_FORM_AUTOFILL_FIELD.attachments]: '2b3c006ef4',
            [WEB_FORM_AUTOFILL_FIELD.orderSN]: 'e98105d0ba',
          },
        },
      },
      [EnvEnum.LIVE]: {
        [WEB_FORM_TYPE.Normal]: {
          url: 'https://help.shopee.co.id/portal/webform/888adc066bf3426a8c70227470281818',
          fieldIdMap: {
            [WEB_FORM_AUTOFILL_FIELD.userType]: '97583cad69',
            [WEB_FORM_AUTOFILL_FIELD.enquiryType]: '64972ef7d5',
            [WEB_FORM_AUTOFILL_FIELD.description]: '065fd830d2',
            [WEB_FORM_AUTOFILL_FIELD.attachments]: 'ec4b0a8786',
          },
        },
        [WEB_FORM_TYPE.Premium]: {
          url: 'https://help.shopee.co.id/portal/webform/549e8e7e672f450bb710d1a31d6a6a6f',
          fieldIdMap: {
            [WEB_FORM_AUTOFILL_FIELD.userType]: 'aa5d9b9eb1',
            [WEB_FORM_AUTOFILL_FIELD.enquiryType]: '0f045499f7',
            [WEB_FORM_AUTOFILL_FIELD.description]: '94a0d6ae88',
            [WEB_FORM_AUTOFILL_FIELD.attachments]: '353033ba7d',
          },
        },
      },
    },
    [COUNTRIES.SG]: {
      [EnvEnum.TEST]: {
        [WEB_FORM_TYPE.Normal]: {
          url: 'https://help.test.shopee.sg/portal/webform/55161bb8f3b14a788cf2d06b714fd136',
          fieldIdMap: {
            [WEB_FORM_AUTOFILL_FIELD.userType]: '31aa7595ea',
            [WEB_FORM_AUTOFILL_FIELD.enquiryType]: 'd9bf313b14',
            [WEB_FORM_AUTOFILL_FIELD.description]: '59286c8df1',
            [WEB_FORM_AUTOFILL_FIELD.attachments]: '2b3c006ef4',
            [WEB_FORM_AUTOFILL_FIELD.orderSN]: 'e98105d0ba',
          },
        },
        [WEB_FORM_TYPE.Premium]: {
          url: 'https://help.test.shopee.sg/portal/webform/55161bb8f3b14a788cf2d06b714fd136',
          fieldIdMap: {
            [WEB_FORM_AUTOFILL_FIELD.userType]: '31aa7595ea',
            [WEB_FORM_AUTOFILL_FIELD.enquiryType]: 'd9bf313b14',
            [WEB_FORM_AUTOFILL_FIELD.description]: '59286c8df1',
            [WEB_FORM_AUTOFILL_FIELD.attachments]: '2b3c006ef4',
            [WEB_FORM_AUTOFILL_FIELD.orderSN]: 'e98105d0ba',
          },
        },
      },
      [EnvEnum.UAT]: {
        [WEB_FORM_TYPE.Normal]: {
          url: 'https://help.uat.shopee.sg/portal/webform/2a2e2efc8d32421eaa7b3a3cb82b2e6a',
          fieldIdMap: {
            [WEB_FORM_AUTOFILL_FIELD.userType]: '31aa7595ea',
            [WEB_FORM_AUTOFILL_FIELD.enquiryType]: 'd9bf313b14',
            [WEB_FORM_AUTOFILL_FIELD.description]: '59286c8df1',
            [WEB_FORM_AUTOFILL_FIELD.attachments]: '2b3c006ef4',
            [WEB_FORM_AUTOFILL_FIELD.orderSN]: 'e98105d0ba',
          },
        },
        [WEB_FORM_TYPE.Premium]: {
          url: 'https://help.uat.shopee.sg/portal/webform/2a2e2efc8d32421eaa7b3a3cb82b2e6a',
          fieldIdMap: {
            [WEB_FORM_AUTOFILL_FIELD.userType]: '31aa7595ea',
            [WEB_FORM_AUTOFILL_FIELD.enquiryType]: 'd9bf313b14',
            [WEB_FORM_AUTOFILL_FIELD.description]: '59286c8df1',
            [WEB_FORM_AUTOFILL_FIELD.attachments]: '2b3c006ef4',
            [WEB_FORM_AUTOFILL_FIELD.orderSN]: 'e98105d0ba',
          },
        },
      },
      [EnvEnum.LIVE]: {
        [WEB_FORM_TYPE.Normal]: {
          url: 'https://help.shopee.sg/portal/webform/7a48024995c847d9a4586bab9fde57a7',
          fieldIdMap: {
            [WEB_FORM_AUTOFILL_FIELD.userType]: '31aa7595ea',
            [WEB_FORM_AUTOFILL_FIELD.enquiryType]: 'd9bf313b14',
            [WEB_FORM_AUTOFILL_FIELD.description]: '59286c8df1',
            [WEB_FORM_AUTOFILL_FIELD.attachments]: '2b3c006ef4',
            [WEB_FORM_AUTOFILL_FIELD.orderSN]: 'e98105d0ba',
          },
        },
        [WEB_FORM_TYPE.Premium]: {
          url: 'https://help.shopee.sg/portal/webform/69717c36e9ac42aea0d442457148fcdc',
          fieldIdMap: {
            [WEB_FORM_AUTOFILL_FIELD.userType]: '542c6d4644',
            [WEB_FORM_AUTOFILL_FIELD.enquiryType]: '8e3d7d1ca7',
            [WEB_FORM_AUTOFILL_FIELD.description]: '59286c8df1',
            [WEB_FORM_AUTOFILL_FIELD.attachments]: '2b3c006ef4',
            [WEB_FORM_AUTOFILL_FIELD.orderSN]: '6e8646a733',
          },
        },
      },
    },
    [COUNTRIES.MX]: {
      [EnvEnum.TEST]: {
        [WEB_FORM_TYPE.Normal]: {
          url: 'https://help.test.shopee.com.mx/portal/webform/e8ee4789ebbd4353b0d184ce401e0955',
          fieldIdMap: {
            [WEB_FORM_AUTOFILL_FIELD.userType]: 'a17672d5d2',
            [WEB_FORM_AUTOFILL_FIELD.enquiryType]: '8d5113511d',
          },
        },
        [WEB_FORM_TYPE.Premium]: {
          url: 'https://help.test.shopee.com.mx/portal/webform/e8ee4789ebbd4353b0d184ce401e0955',
          fieldIdMap: {
            [WEB_FORM_AUTOFILL_FIELD.userType]: 'a17672d5d2',
            [WEB_FORM_AUTOFILL_FIELD.enquiryType]: '8d5113511d',
          },
        },
      },
      [EnvEnum.UAT]: {
        [WEB_FORM_TYPE.Normal]: {
          url: 'https://help.uat.shopee.com.mx/portal/webform/618a16d19d254102a2f051454a65c02e',
          fieldIdMap: {
            [WEB_FORM_AUTOFILL_FIELD.userType]: '56a38729c8',
            [WEB_FORM_AUTOFILL_FIELD.enquiryType]: '8a13b6f8be',
          },
        },
        [WEB_FORM_TYPE.Premium]: {
          url: 'https://help.uat.shopee.com.mx/portal/webform/618a16d19d254102a2f051454a65c02e',
          fieldIdMap: {
            [WEB_FORM_AUTOFILL_FIELD.userType]: '56a38729c8',
            [WEB_FORM_AUTOFILL_FIELD.enquiryType]: '8a13b6f8be',
          },
        },
      },
      [EnvEnum.LIVE]: {
        [WEB_FORM_TYPE.Normal]: {
          url: 'https://help.shopee.com.mx/portal/webform/e58cb9c620f54aec9e18a01632c35c05',
          fieldIdMap: {
            [WEB_FORM_AUTOFILL_FIELD.userType]: '3a92e53322',
            [WEB_FORM_AUTOFILL_FIELD.enquiryType]: 'ecd764196b',
            [WEB_FORM_AUTOFILL_FIELD.description]: 'd8cc2c2790',
            [WEB_FORM_AUTOFILL_FIELD.attachments]: '82a2834654',
            [WEB_FORM_AUTOFILL_FIELD.orderSN]: '7e8a057e95',
          },
        },
        [WEB_FORM_TYPE.Premium]: {
          url: 'https://help.shopee.com.mx/portal/webform/e58cb9c620f54aec9e18a01632c35c05',
          fieldIdMap: {
            [WEB_FORM_AUTOFILL_FIELD.userType]: '3a92e53322',
            [WEB_FORM_AUTOFILL_FIELD.enquiryType]: 'ecd764196b',
            [WEB_FORM_AUTOFILL_FIELD.description]: 'd8cc2c2790',
            [WEB_FORM_AUTOFILL_FIELD.attachments]: '82a2834654',
            [WEB_FORM_AUTOFILL_FIELD.orderSN]: '7e8a057e95',
          },
        },
      },
    },
    [COUNTRIES.BR]: {
      [EnvEnum.TEST]: {
        [WEB_FORM_TYPE.Normal]: {
          url: 'https://help.test.shopee.com.br/portal/webform/ae824f41791f45c7ae4c7292505adba7',
          fieldIdMap: {
            [WEB_FORM_AUTOFILL_FIELD.userType]: '31aa7595ea',
            [WEB_FORM_AUTOFILL_FIELD.enquiryType]: 'd9bf313b14',
            [WEB_FORM_AUTOFILL_FIELD.description]: '59286c8df1',
            [WEB_FORM_AUTOFILL_FIELD.attachments]: '2b3c006ef4',
            [WEB_FORM_AUTOFILL_FIELD.orderSN]: 'e98105d0ba',
          },
        },
        [WEB_FORM_TYPE.Premium]: {
          url: 'https://help.test.shopee.com.br/portal/webform/ae824f41791f45c7ae4c7292505adba7',
          fieldIdMap: {
            [WEB_FORM_AUTOFILL_FIELD.userType]: '31aa7595ea',
            [WEB_FORM_AUTOFILL_FIELD.enquiryType]: 'd9bf313b14',
            [WEB_FORM_AUTOFILL_FIELD.description]: '59286c8df1',
            [WEB_FORM_AUTOFILL_FIELD.attachments]: '2b3c006ef4',
            [WEB_FORM_AUTOFILL_FIELD.orderSN]: 'e98105d0ba',
          },
        },
      },
      [EnvEnum.UAT]: {
        [WEB_FORM_TYPE.Normal]: {
          url: 'https://help.uat.shopee.com.br/portal/webform/ef451a149e604a9188337a1c3ccf111d',
          fieldIdMap: {
            [WEB_FORM_AUTOFILL_FIELD.userType]: '31aa7595ea',
            [WEB_FORM_AUTOFILL_FIELD.enquiryType]: 'd9bf313b14',
            [WEB_FORM_AUTOFILL_FIELD.description]: '59286c8df1',
            [WEB_FORM_AUTOFILL_FIELD.attachments]: '2b3c006ef4',
            [WEB_FORM_AUTOFILL_FIELD.orderSN]: 'e98105d0ba',
          },
        },
        [WEB_FORM_TYPE.Premium]: {
          url: 'https://help.uat.shopee.com.br/portal/webform/ef451a149e604a9188337a1c3ccf111d',
          fieldIdMap: {
            [WEB_FORM_AUTOFILL_FIELD.userType]: '31aa7595ea',
            [WEB_FORM_AUTOFILL_FIELD.enquiryType]: 'd9bf313b14',
            [WEB_FORM_AUTOFILL_FIELD.description]: '59286c8df1',
            [WEB_FORM_AUTOFILL_FIELD.attachments]: '2b3c006ef4',
            [WEB_FORM_AUTOFILL_FIELD.orderSN]: 'e98105d0ba',
          },
        },
      },
      [EnvEnum.LIVE]: {
        [WEB_FORM_TYPE.Normal]: {
          url: 'https://help.shopee.com.br/portal/webform/d75e2dbb49594bd19d1ea83485339a45',
          fieldIdMap: {
            [WEB_FORM_AUTOFILL_FIELD.userType]: '3a92e53322',
            [WEB_FORM_AUTOFILL_FIELD.enquiryType]: 'ecd764196b',
            [WEB_FORM_AUTOFILL_FIELD.description]: 'd8cc2c2790',
            [WEB_FORM_AUTOFILL_FIELD.attachments]: '82a2834654',
            [WEB_FORM_AUTOFILL_FIELD.orderSN]: '7dc5cc852b',
          },
        },
        [WEB_FORM_TYPE.Premium]: {
          url: 'https://help.shopee.com.br/portal/webform/d75e2dbb49594bd19d1ea83485339a45',
          fieldIdMap: {
            [WEB_FORM_AUTOFILL_FIELD.userType]: '3a92e53322',
            [WEB_FORM_AUTOFILL_FIELD.enquiryType]: 'ecd764196b',
            [WEB_FORM_AUTOFILL_FIELD.description]: 'd8cc2c2790',
            [WEB_FORM_AUTOFILL_FIELD.attachments]: '82a2834654',
            [WEB_FORM_AUTOFILL_FIELD.orderSN]: '7dc5cc852b',
          },
        },
      },
    },
    [COUNTRIES.CO]: {
      [EnvEnum.TEST]: {
        [WEB_FORM_TYPE.Normal]: {
          url: 'https://help.test.shopee.com.co/portal/webform/a65cab3a39b3415db5bd6953fde53e8c',
          fieldIdMap: {
            [WEB_FORM_AUTOFILL_FIELD.userType]: '2d0b9ba536',
            [WEB_FORM_AUTOFILL_FIELD.enquiryType]: 'a6cc3222b5',
          },
        },
        [WEB_FORM_TYPE.Premium]: {
          url: 'https://help.test.shopee.com.co/portal/webform/a65cab3a39b3415db5bd6953fde53e8c',
          fieldIdMap: {
            [WEB_FORM_AUTOFILL_FIELD.userType]: '2d0b9ba536',
            [WEB_FORM_AUTOFILL_FIELD.enquiryType]: 'a6cc3222b5',
          },
        },
      },
      [EnvEnum.UAT]: {
        [WEB_FORM_TYPE.Normal]: {
          url: 'https://help.uat.shopee.com.co/portal/webform/21d9d76e2ba24f3db3dbf645bbf6e406',
          fieldIdMap: {
            [WEB_FORM_AUTOFILL_FIELD.userType]: '76e9bb186b',
            [WEB_FORM_AUTOFILL_FIELD.enquiryType]: '5f935039da',
          },
        },
        [WEB_FORM_TYPE.Premium]: {
          url: 'https://help.uat.shopee.com.co/portal/webform/21d9d76e2ba24f3db3dbf645bbf6e406',
          fieldIdMap: {
            [WEB_FORM_AUTOFILL_FIELD.userType]: '76e9bb186b',
            [WEB_FORM_AUTOFILL_FIELD.enquiryType]: '5f935039da',
          },
        },
      },
      [EnvEnum.LIVE]: {
        [WEB_FORM_TYPE.Normal]: {
          url: 'https://help.shopee.com.co/portal/webform/a503e7f7bc4849c0824985ddd9659d33',
          fieldIdMap: {
            [WEB_FORM_AUTOFILL_FIELD.userType]: '3a92e53322',
            [WEB_FORM_AUTOFILL_FIELD.enquiryType]: 'ecd764196b',
            [WEB_FORM_AUTOFILL_FIELD.description]: 'd8cc2c2790',
            [WEB_FORM_AUTOFILL_FIELD.orderSN]: '50019fac5f',
          },
        },
        [WEB_FORM_TYPE.Premium]: {
          url: 'https://help.shopee.com.co/portal/webform/a503e7f7bc4849c0824985ddd9659d33',
          fieldIdMap: {
            [WEB_FORM_AUTOFILL_FIELD.userType]: '3a92e53322',
            [WEB_FORM_AUTOFILL_FIELD.enquiryType]: 'ecd764196b',
            [WEB_FORM_AUTOFILL_FIELD.description]: 'd8cc2c2790',
            [WEB_FORM_AUTOFILL_FIELD.orderSN]: '50019fac5f',
          },
        },
      },
    },
    [COUNTRIES.CL]: {
      [EnvEnum.TEST]: {
        [WEB_FORM_TYPE.Normal]: {
          url: 'https://help.test.shopee.cl/portal/webform/9ac21b880c5e48d3a7c4bded12530e1a',
          fieldIdMap: {
            [WEB_FORM_AUTOFILL_FIELD.userType]: '05038b1490',
            [WEB_FORM_AUTOFILL_FIELD.enquiryType]: '20ed23246c',
          },
        },
        [WEB_FORM_TYPE.Premium]: {
          url: 'https://help.test.shopee.cl/portal/webform/9ac21b880c5e48d3a7c4bded12530e1a',
          fieldIdMap: {
            [WEB_FORM_AUTOFILL_FIELD.userType]: '05038b1490',
            [WEB_FORM_AUTOFILL_FIELD.enquiryType]: '20ed23246c',
          },
        },
      },
      [EnvEnum.UAT]: {
        [WEB_FORM_TYPE.Normal]: {
          url: 'https://help.uat.shopee.cl/portal/webform/1fc6d71e6cfb4844b4657683c5fa6787',
          fieldIdMap: {
            [WEB_FORM_AUTOFILL_FIELD.userType]: 'ae478685b3',
            [WEB_FORM_AUTOFILL_FIELD.enquiryType]: 'e0dbb137da',
          },
        },
        [WEB_FORM_TYPE.Premium]: {
          url: 'https://help.uat.shopee.cl/portal/webform/1fc6d71e6cfb4844b4657683c5fa6787',
          fieldIdMap: {
            [WEB_FORM_AUTOFILL_FIELD.userType]: 'ae478685b3',
            [WEB_FORM_AUTOFILL_FIELD.enquiryType]: 'e0dbb137da',
          },
        },
      },
      [EnvEnum.LIVE]: {
        [WEB_FORM_TYPE.Normal]: {
          url: 'https://help.shopee.cl/portal/webform/5484e709da71430cb8980abc5cef14f0',
          fieldIdMap: {
            [WEB_FORM_AUTOFILL_FIELD.userType]: '3a92e53322',
            [WEB_FORM_AUTOFILL_FIELD.enquiryType]: 'ecd764196b',
            [WEB_FORM_AUTOFILL_FIELD.description]: 'd8cc2c2790',
            [WEB_FORM_AUTOFILL_FIELD.attachments]: '82a2834654',
            [WEB_FORM_AUTOFILL_FIELD.orderSN]: '3c70cc9df5',
          },
        },
        [WEB_FORM_TYPE.Premium]: {
          url: 'https://help.shopee.cl/portal/webform/5484e709da71430cb8980abc5cef14f0',
          fieldIdMap: {
            [WEB_FORM_AUTOFILL_FIELD.userType]: '3a92e53322',
            [WEB_FORM_AUTOFILL_FIELD.enquiryType]: 'ecd764196b',
            [WEB_FORM_AUTOFILL_FIELD.description]: 'd8cc2c2790',
            [WEB_FORM_AUTOFILL_FIELD.attachments]: '82a2834654',
            [WEB_FORM_AUTOFILL_FIELD.orderSN]: '3c70cc9df5',
          },
        },
      },
    },
    [COUNTRIES.VN]: {
      [EnvEnum.TEST]: {
        [WEB_FORM_TYPE.Normal]: {
          url: 'https://help.test.shopee.vn/portal/webform/3491efa01d424a1495bb0e854f09fd81',
          fieldIdMap: {
            [WEB_FORM_AUTOFILL_FIELD.userType]: '541ee5bb7d',
            [WEB_FORM_AUTOFILL_FIELD.enquiryType]: '8bacb2d891',
          },
        },
        [WEB_FORM_TYPE.Premium]: {
          url: 'https://help.test.shopee.vn/portal/webform/3491efa01d424a1495bb0e854f09fd81',
          fieldIdMap: {
            [WEB_FORM_AUTOFILL_FIELD.userType]: '541ee5bb7d',
            [WEB_FORM_AUTOFILL_FIELD.enquiryType]: '8bacb2d891',
          },
        },
      },
      [EnvEnum.UAT]: {
        [WEB_FORM_TYPE.Normal]: {
          url: 'https://help.uat.shopee.vn/portal/webform/bdb1b308a6a04556ba3fa6fa8a446034',
          fieldIdMap: {
            [WEB_FORM_AUTOFILL_FIELD.userType]: '10088eae06',
            [WEB_FORM_AUTOFILL_FIELD.enquiryType]: '31dd0fa01d',
          },
        },
        [WEB_FORM_TYPE.Premium]: {
          url: 'https://help.uat.shopee.vn/portal/webform/bdb1b308a6a04556ba3fa6fa8a446034',
          fieldIdMap: {
            [WEB_FORM_AUTOFILL_FIELD.userType]: '10088eae06',
            [WEB_FORM_AUTOFILL_FIELD.enquiryType]: '31dd0fa01d',
          },
        },
      },
      [EnvEnum.LIVE]: {
        [WEB_FORM_TYPE.Normal]: {
          url: 'https://help.shopee.vn/portal/webform/9e0e87184cf14246aabe6af0d78b2aa9',
          fieldIdMap: {
            [WEB_FORM_AUTOFILL_FIELD.userType]: '31aa7595ea',
            [WEB_FORM_AUTOFILL_FIELD.enquiryType]: 'd9bf313b14',
            [WEB_FORM_AUTOFILL_FIELD.description]: '59286c8df1',
            [WEB_FORM_AUTOFILL_FIELD.attachments]: '2b3c006ef4',
            [WEB_FORM_AUTOFILL_FIELD.orderSN]: '2df0a81d1b',
          },
        },
        [WEB_FORM_TYPE.Premium]: {
          url: 'https://help.shopee.vn/portal/webform/9e0e87184cf14246aabe6af0d78b2aa9',
          fieldIdMap: {
            [WEB_FORM_AUTOFILL_FIELD.userType]: '31aa7595ea',
            [WEB_FORM_AUTOFILL_FIELD.enquiryType]: 'd9bf313b14',
            [WEB_FORM_AUTOFILL_FIELD.description]: '59286c8df1',
            [WEB_FORM_AUTOFILL_FIELD.attachments]: '2b3c006ef4',
            [WEB_FORM_AUTOFILL_FIELD.orderSN]: '2df0a81d1b',
          },
        },
      },
    },
    [COUNTRIES.TW]: {
      [EnvEnum.TEST]: {
        [WEB_FORM_TYPE.Normal]: {
          url: 'https://help.test.shopee.tw/portal/webform/b535f46013504c6f99d2f79d01135912',
          fieldIdMap: {
            [WEB_FORM_AUTOFILL_FIELD.userType]: '3fa627bb28',
            [WEB_FORM_AUTOFILL_FIELD.enquiryType]: '4080c08b4c',
          },
        },
        [WEB_FORM_TYPE.Premium]: {
          url: 'https://help.test.shopee.tw/portal/webform/b535f46013504c6f99d2f79d01135912',
          fieldIdMap: {
            [WEB_FORM_AUTOFILL_FIELD.userType]: '3fa627bb28',
            [WEB_FORM_AUTOFILL_FIELD.enquiryType]: '4080c08b4c',
          },
        },
      },
      [EnvEnum.UAT]: {
        [WEB_FORM_TYPE.Normal]: {
          url: 'https://help.uat.shopee.tw/portal/webform/2ccab23ea9b244658366cb71884270f7',
          fieldIdMap: {
            [WEB_FORM_AUTOFILL_FIELD.userType]: '87c3b1cab8',
            [WEB_FORM_AUTOFILL_FIELD.enquiryType]: 'df2cd8182f',
          },
        },
        [WEB_FORM_TYPE.Premium]: {
          url: 'https://help.uat.shopee.tw/portal/webform/2ccab23ea9b244658366cb71884270f7',
          fieldIdMap: {
            [WEB_FORM_AUTOFILL_FIELD.userType]: '87c3b1cab8',
            [WEB_FORM_AUTOFILL_FIELD.enquiryType]: 'df2cd8182f',
          },
        },
      },
      [EnvEnum.LIVE]: {
        [WEB_FORM_TYPE.Normal]: {
          url: 'https://help.shopee.tw/portal/webform/e0ec9e59d5594f7c8354b84856f48f51',
          fieldIdMap: {
            [WEB_FORM_AUTOFILL_FIELD.userType]: '899c27d3c3',
            [WEB_FORM_AUTOFILL_FIELD.enquiryType]: '844ef874e2',
            [WEB_FORM_AUTOFILL_FIELD.description]: 'fe234a7ca2',
            [WEB_FORM_AUTOFILL_FIELD.attachments]: 'e8a06c3c93',
            [WEB_FORM_AUTOFILL_FIELD.orderSN]: '51f2296563',
          },
        },
        [WEB_FORM_TYPE.Premium]: {
          url: 'https://help.shopee.tw/portal/webform/9f1cecc47819456dbb5728d2a6d8059e',
          fieldIdMap: {
            [WEB_FORM_AUTOFILL_FIELD.userType]: '719198e013',
            [WEB_FORM_AUTOFILL_FIELD.enquiryType]: '3e0700afa4',
            [WEB_FORM_AUTOFILL_FIELD.description]: 'efc56ef190',
            [WEB_FORM_AUTOFILL_FIELD.attachments]: 'e126f690df',
            [WEB_FORM_AUTOFILL_FIELD.orderSN]: '50e0597df5',
          },
        },
      },
    },
    [COUNTRIES.MY]: {
      [EnvEnum.TEST]: {
        [WEB_FORM_TYPE.Normal]: {
          url: 'https://help.test.shopee.com.my/portal/webform/dd8b9cd30b574c228a40b9430076d5b2',
          fieldIdMap: {
            [WEB_FORM_AUTOFILL_FIELD.userType]: '8da0299b3d',
            [WEB_FORM_AUTOFILL_FIELD.enquiryType]: '95543f0688',
          },
        },
        [WEB_FORM_TYPE.Premium]: {
          url: 'https://help.test.shopee.com.my/portal/webform/dd8b9cd30b574c228a40b9430076d5b2',
          fieldIdMap: {
            [WEB_FORM_AUTOFILL_FIELD.userType]: '8da0299b3d',
            [WEB_FORM_AUTOFILL_FIELD.enquiryType]: '95543f0688',
          },
        },
      },
      [EnvEnum.UAT]: {
        [WEB_FORM_TYPE.Normal]: {
          url: 'https://help.uat.shopee.com.my/portal/webform/5df89a77cbe746f9909b4f495ff68173',
          fieldIdMap: {
            [WEB_FORM_AUTOFILL_FIELD.userType]: '9757633996',
            [WEB_FORM_AUTOFILL_FIELD.enquiryType]: 'dae59dad46',
          },
        },
        [WEB_FORM_TYPE.Premium]: {
          url: 'https://help.uat.shopee.com.my/portal/webform/5df89a77cbe746f9909b4f495ff68173',
          fieldIdMap: {
            [WEB_FORM_AUTOFILL_FIELD.userType]: '9757633996',
            [WEB_FORM_AUTOFILL_FIELD.enquiryType]: 'dae59dad46',
          },
        },
      },
      [EnvEnum.LIVE]: {
        [WEB_FORM_TYPE.Normal]: {
          url: 'https://help.shopee.com.my/portal/webform/b7a7ff2afd484f1dbddb3a922c7e90e7',
          fieldIdMap: {
            [WEB_FORM_AUTOFILL_FIELD.userType]: '31aa7595ea',
            [WEB_FORM_AUTOFILL_FIELD.enquiryType]: 'd9bf313b14',
            [WEB_FORM_AUTOFILL_FIELD.description]: 'c501500542',
            [WEB_FORM_AUTOFILL_FIELD.attachments]: '2b3c006ef4',
            [WEB_FORM_AUTOFILL_FIELD.orderSN]: '5d8a7c06e8',
          },
        },
        [WEB_FORM_TYPE.Premium]: {
          url: 'https://help.shopee.com.my/portal/webform/b7a7ff2afd484f1dbddb3a922c7e90e7',
          fieldIdMap: {
            [WEB_FORM_AUTOFILL_FIELD.userType]: '31aa7595ea',
            [WEB_FORM_AUTOFILL_FIELD.enquiryType]: 'd9bf313b14',
            [WEB_FORM_AUTOFILL_FIELD.description]: 'c501500542',
            [WEB_FORM_AUTOFILL_FIELD.attachments]: '2b3c006ef4',
            [WEB_FORM_AUTOFILL_FIELD.orderSN]: '5d8a7c06e8',
          },
        },
      },
    },
    [COUNTRIES.TH]: {
      [EnvEnum.TEST]: {
        [WEB_FORM_TYPE.Normal]: {
          url: 'https://help.test.shopee.co.th/portal/webform/cba6309f3d12499ca3c70ad413f59156',
          fieldIdMap: {
            [WEB_FORM_AUTOFILL_FIELD.userType]: '6f3d5f602d',
            [WEB_FORM_AUTOFILL_FIELD.enquiryType]: 'f1483ab78e',
          },
        },
        [WEB_FORM_TYPE.Premium]: {
          url: 'https://help.test.shopee.co.th/portal/webform/cba6309f3d12499ca3c70ad413f59156',
          fieldIdMap: {
            [WEB_FORM_AUTOFILL_FIELD.userType]: '6f3d5f602d',
            [WEB_FORM_AUTOFILL_FIELD.enquiryType]: 'f1483ab78e',
          },
        },
      },
      [EnvEnum.UAT]: {
        [WEB_FORM_TYPE.Normal]: {
          url: 'https://help.uat.shopee.co.th/portal/webform/d05764dca49e4773aba918d9b7fafe3b',
          fieldIdMap: {
            [WEB_FORM_AUTOFILL_FIELD.userType]: '95919c776d',
            [WEB_FORM_AUTOFILL_FIELD.enquiryType]: 'e35fca7632',
          },
        },
        [WEB_FORM_TYPE.Premium]: {
          url: 'https://help.uat.shopee.co.th/portal/webform/d05764dca49e4773aba918d9b7fafe3b',
          fieldIdMap: {
            [WEB_FORM_AUTOFILL_FIELD.userType]: '95919c776d',
            [WEB_FORM_AUTOFILL_FIELD.enquiryType]: 'e35fca7632',
          },
        },
      },
      [EnvEnum.LIVE]: {
        [WEB_FORM_TYPE.Normal]: {
          url: 'https://help.shopee.co.th/portal/webform/38e4b86fd0c04ae3b2c9200c7ea9c89e',
          fieldIdMap: {
            [WEB_FORM_AUTOFILL_FIELD.userType]: '31aa7595ea',
            [WEB_FORM_AUTOFILL_FIELD.enquiryType]: 'd9bf313b14',
            [WEB_FORM_AUTOFILL_FIELD.description]: '59286c8df1',
            [WEB_FORM_AUTOFILL_FIELD.attachments]: '2b3c006ef4',
            [WEB_FORM_AUTOFILL_FIELD.orderSN]: '5f0739a4d9',
          },
        },
        [WEB_FORM_TYPE.Premium]: {
          url: 'https://help.shopee.co.th/portal/webform/38e4b86fd0c04ae3b2c9200c7ea9c89e',
          fieldIdMap: {
            [WEB_FORM_AUTOFILL_FIELD.userType]: '31aa7595ea',
            [WEB_FORM_AUTOFILL_FIELD.enquiryType]: 'd9bf313b14',
            [WEB_FORM_AUTOFILL_FIELD.description]: '59286c8df1',
            [WEB_FORM_AUTOFILL_FIELD.attachments]: '5f0739a4d9',
            [WEB_FORM_AUTOFILL_FIELD.orderSN]: '5f0739a4d9',
          },
        },
      },
    },
    [COUNTRIES.PH]: {
      [EnvEnum.TEST]: {
        [WEB_FORM_TYPE.Normal]: {
          url: 'https://help.test.shopee.ph/portal/webform/50b81eb0366c481da32e139d533e6e6c',
          fieldIdMap: {
            [WEB_FORM_AUTOFILL_FIELD.userType]: '3ffebeaddc',
            [WEB_FORM_AUTOFILL_FIELD.enquiryType]: '8ee0dc4bd2',
          },
        },
        [WEB_FORM_TYPE.Premium]: {
          url: 'https://help.test.shopee.ph/portal/webform/50b81eb0366c481da32e139d533e6e6c',
          fieldIdMap: {
            [WEB_FORM_AUTOFILL_FIELD.userType]: '3ffebeaddc',
            [WEB_FORM_AUTOFILL_FIELD.enquiryType]: '8ee0dc4bd2',
          },
        },
      },
      [EnvEnum.UAT]: {
        [WEB_FORM_TYPE.Normal]: {
          url: 'https://help.uat.shopee.ph/portal/webform/40a4b6d211714842bf59a824cb4f28b6',
          fieldIdMap: {
            [WEB_FORM_AUTOFILL_FIELD.userType]: 'd487c0c0a3',
            [WEB_FORM_AUTOFILL_FIELD.enquiryType]: '9e1fb5780c',
          },
        },
        [WEB_FORM_TYPE.Premium]: {
          url: 'https://help.uat.shopee.ph/portal/webform/40a4b6d211714842bf59a824cb4f28b6',
          fieldIdMap: {
            [WEB_FORM_AUTOFILL_FIELD.userType]: 'd487c0c0a3',
            [WEB_FORM_AUTOFILL_FIELD.enquiryType]: '9e1fb5780c',
          },
        },
      },
      [EnvEnum.LIVE]: {
        [WEB_FORM_TYPE.Normal]: {
          url: 'https://help.shopee.ph/portal/webform/bafd4812311d417c981d2690cda870bf',
          fieldIdMap: {
            [WEB_FORM_AUTOFILL_FIELD.userType]: '31aa7595ea',
            [WEB_FORM_AUTOFILL_FIELD.enquiryType]: 'd9bf313b14',
            [WEB_FORM_AUTOFILL_FIELD.orderSN]: 'e00d59fdf9',
          },
        },
        [WEB_FORM_TYPE.Premium]: {
          url: 'https://help.shopee.ph/portal/webform/6e964e5801e749debadffefb75d33a55',
          fieldIdMap: {
            [WEB_FORM_AUTOFILL_FIELD.userType]: '542c6d4644',
            [WEB_FORM_AUTOFILL_FIELD.enquiryType]: '8e3d7d1ca7',
            [WEB_FORM_AUTOFILL_FIELD.description]: '1456a5912e',
            [WEB_FORM_AUTOFILL_FIELD.attachments]: '571d283cf7',
            [WEB_FORM_AUTOFILL_FIELD.orderSN]: 'b36e61d71e',
          },
        },
      },
    },
    [COUNTRIES.PL]: {
      [EnvEnum.TEST]: {
        [WEB_FORM_TYPE.Normal]: {
          url: 'https://help.test.shopee.pl/portal/webform/a23d309abcee4b4a88fd76e1bd675c6a',
          fieldIdMap: {
            [WEB_FORM_AUTOFILL_FIELD.userType]: '47a14870d6',
            [WEB_FORM_AUTOFILL_FIELD.enquiryType]: '03c985a1fe',
          },
        },
        [WEB_FORM_TYPE.Premium]: {
          url: 'https://help.test.shopee.pl/portal/webform/a23d309abcee4b4a88fd76e1bd675c6a',
          fieldIdMap: {
            [WEB_FORM_AUTOFILL_FIELD.userType]: '47a14870d6',
            [WEB_FORM_AUTOFILL_FIELD.enquiryType]: '03c985a1fe',
          },
        },
      },
      [EnvEnum.UAT]: {
        [WEB_FORM_TYPE.Normal]: {
          url: 'https://help.uat.shopee.pl/portal/webform/47cf560dfc4d4edeab86af7c6421bfb3',
          fieldIdMap: {
            [WEB_FORM_AUTOFILL_FIELD.userType]: 'd8c3624d28',
            [WEB_FORM_AUTOFILL_FIELD.enquiryType]: '88ee7ee2cd',
          },
        },
        [WEB_FORM_TYPE.Premium]: {
          url: 'https://help.uat.shopee.pl/portal/webform/47cf560dfc4d4edeab86af7c6421bfb3',
          fieldIdMap: {
            [WEB_FORM_AUTOFILL_FIELD.userType]: 'd8c3624d28',
            [WEB_FORM_AUTOFILL_FIELD.enquiryType]: '88ee7ee2cd',
          },
        },
      },
      [EnvEnum.LIVE]: {
        [WEB_FORM_TYPE.Normal]: {
          url: 'https://help.shopee.pl/portal/webform/3e8f2872acee4938951fa12e61f5b3f6',
          fieldIdMap: {
            [WEB_FORM_AUTOFILL_FIELD.userType]: 'f4c6a0307c',
            [WEB_FORM_AUTOFILL_FIELD.enquiryType]: '885444ac17',
            [WEB_FORM_AUTOFILL_FIELD.description]: 'cbe053b46d',
            [WEB_FORM_AUTOFILL_FIELD.attachments]: 'b5d54f15e7',
            [WEB_FORM_AUTOFILL_FIELD.orderSN]: '82d21fb98c',
          },
        },
        [WEB_FORM_TYPE.Premium]: {
          url: 'https://help.shopee.pl/portal/webform/3e8f2872acee4938951fa12e61f5b3f6',
          fieldIdMap: {
            [WEB_FORM_AUTOFILL_FIELD.userType]: 'f4c6a0307c',
            [WEB_FORM_AUTOFILL_FIELD.enquiryType]: '885444ac17',
            [WEB_FORM_AUTOFILL_FIELD.description]: 'cbe053b46d',
            [WEB_FORM_AUTOFILL_FIELD.attachments]: 'b5d54f15e7',
            [WEB_FORM_AUTOFILL_FIELD.orderSN]: '82d21fb98c',
          },
        },
      },
    },
  }[COUNTRY]?.[ENVIRONMENT] || {};
